<template>
    <div class="bg-sso page-select-phone">
        <LoadingSSO :isShow="loading" />
        <div class="wrapper_logo_sso">
            <img src="../../assets/ssoauth/iconsso.svg" />
        </div>
        <div class="wrapper_card_sso">
            <div class="title">
                ยืนยันตัวตน
            </div>
            <div class="wrap-account">
                <InputContactNumber
                    inputId="contact-number"
                    delimeter="-"
                    v-model="contactNo"
                    :showLabel="false"
                    :inputLbl="localePage.contactnumber"
                    :isFirstSave="isFirstSave"
                    :isShowErrorLbl="true"
                    :errorInfo="errorInfo[0]"
                    :disabled="false"
                    @input="onChange()"
                ></InputContactNumber>
            </div>
            <div v-if="errMessage" class="error-message">
                {{ errMessage }}
            </div>
            <div>
                <button
                    :class="{ disabled: isDisabledSubmit }"
                    class="button-account"
                    @click="onclicknext()"
                >
                    ถัดไป
                </button>
            </div>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
//component
import InputContactNumber from "@/components/Input/ContactNumber.vue";
import LoadingSSO from "@/components/LoadingSSO/Loading.vue";
//mixin
import LocaleMixin from "@/mixin/LocaleMixin.js";
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";
import ModalMixin from "@/mixin/ModalMixin.js";
import AccountMixin from "@/mixin/AccountMixin.js";
//service
import BzbsOtp from "@/core/Otp/service/BzbsOtp.js";
//Helper
import FormHelper from "@/helper/FormHelper.js";

export default {
    name: "home",
    components: {
        InputContactNumber,
        LoadingSSO
    },
    mixins: [AccountMixin, LocaleMixin, ErrorApiMixin, ModalMixin],
    data: function() {
        return {
            loading: false,
            localePage: {},
            isLogin: false,
            isFirstSave: true,
            errorInfo: [],
            channel: "ssoregis",
            isDisabledSubmit: true,
            optData: "",
            errMessage: "",

            contactNo: null
        };
    },
    created: function() {
        this.loading = true;
        document.body.classList.add("body-sso");
        this.localePage = this.lbl.profile;
        this.errorInfo = FormHelper.genErrorInfo(1);
        setTimeout(() => {
            this.loading = false;
        }, 500);
    },
    methods: {
        onclicknext: async function() {
            this.loading = true;
            await this.apiRequestOtp();
            this.$router.push({
                name: "otpSso",
                params: {
                    data: this.optData
                }
            });
        },
        apiRequestOtp: async function() {
            return new Promise((resolve, reject) => {
                BzbsOtp.requestOtp(
                    this.contactNo,
                    null,
                    this.channel
                ).subscribe(
                    data => {
                        this.optData = { ...data, contactNo: this.contactNo };
                        this.loading = false;
                        resolve(true);
                    },
                    err => {
                        this.loading = false;
                        let errMsg = err.message;
                        if (err.id == 2078) {
                            errMsg =
                                "ขออภัยค่ะ หมายเลขโทรศัพท์ของท่านมีอยู่แล้วในระบบ กรุณาตรวจสอบอีกครั้ง หากไม่สามารถแก้ไขได้ กรุณาติดต่อศูนย์บริการลูกค้า โทร. 02-6578625";
                        }
                        this.errMessage = errMsg;
                        reject(err);
                    }
                );
            });
        },
        onChange() {
            if (this.errorInfo[0].isValid) {
                this.isDisabledSubmit = false;
            } else {
                this.isDisabledSubmit = true;
            }
            this.errMessage = "";
        }
    }
};
</script>
<style lang="scss" scoped>
@import "@/style/sso.scss";
</style>
